module.exports = __webpack_public_path__ + "static/hero-mockup-mobile-01a37ed1e8f07c1f3024e26efcdfc6f6.png";